export default __webpack_public_path__ + "static/media/recruit_table_icon_1.1c65de6b.svg";